export default __webpack_public_path__ + "static/media/ELECTIVE_BUSINESS_FINANCE.362d3914.svg";